import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from '@/components/Toaster/Toaster';
import { queryClient } from '@/lib/queryClient';
import { showDevChrome } from '@/lib/devChrome';

export function AppProviders({ children }: { children: ReactNode }) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <Toaster />
            {showDevChrome() ? <ReactQueryDevtools buttonPosition="bottom-left" /> : null}
        </QueryClientProvider>
    );
}
